import { Outlet, Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { checkAuth } from './checkAuth';

const ProtectedRoutes = () => {
    const [authenticated, setAuthenticated] = useState(null);

    useEffect(() => {
        (async () => {

            let authenticated = await checkAuth();
            if (!authenticated) {
                setAuthenticated(false);
            }
            else {
                setAuthenticated(true);
            }
        })();
    }, []);

    if (authenticated === null) {
        return null;
    }

    return authenticated ? <Outlet /> : <Navigate to="/Login" />;
}

export default ProtectedRoutes;